export const OPEN_UNLOCK_FEATURE_MODAL = "OPEN_UNLOCK_FEATURE_MODAL";
export const CLOSE_UNLOCK_FEATURE_MODAL = "CLOSE_UNLOCK_FEATURE_MODAL";
